import React from "react";
import i18next from "i18next";
import PropTypes from "prop-types";
import Vegan from "~/static/images/icons/vegan/vegan.svg";
import Salad from "~/static/images/icons/vegan/salad.svg";
import { VEGAN_TYPES } from "./VeganOptions";
import useViewport from "~/assets/js/Helpers/hooks/useViewport";

const VeganToggle = ({ veganType, onToggle }) => {
    const { isMobile } = useViewport();

    if (isMobile) {
        return (
            <div className="vegan-toggle-mobile">
                <div
                    className={`option classic ${
                        veganType === VEGAN_TYPES.CLASSIC ? "active" : ""
                    }`}
                    onClick={
                        veganType === VEGAN_TYPES.VEGAN ? onToggle : () => {}
                    }
                >
                    <img src={Salad} />
                    <p>{i18next.t("productDetails.vegan.type.classic")}</p>
                </div>
                <div
                    className={`option vegan ${
                        veganType === VEGAN_TYPES.VEGAN ? "active" : ""
                    }`}
                    onClick={
                        veganType === VEGAN_TYPES.CLASSIC ? onToggle : () => {}
                    }
                >
                    <img src={Vegan} />
                    <p>{i18next.t("productDetails.vegan.type.vegan")}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="vegan-toggle">
            <p
                className={`option-text ${
                    veganType === VEGAN_TYPES.CLASSIC ? "active" : ""
                }`}
            >
                {i18next.t("productDetails.vegan.type.classic")}
            </p>
            <div className="toggle" onClick={onToggle}>
                <div
                    className={`option classic ${
                        veganType === VEGAN_TYPES.CLASSIC ? "active" : ""
                    }`}
                >
                    <img src={Salad} />
                </div>
                <div
                    className={`option vegan ${
                        veganType === VEGAN_TYPES.VEGAN ? "active" : ""
                    }`}
                >
                    <img src={Vegan} />
                </div>
            </div>
            <p
                className={`option-text ${
                    veganType === VEGAN_TYPES.VEGAN ? "active" : ""
                }`}
            >
                {i18next.t("productDetails.vegan.type.vegan")}
            </p>
        </div>
    );
};

VeganToggle.propTypes = {
    veganType: PropTypes.string.isRequired,
    onToggle: PropTypes.func.isRequired,
};

export default VeganToggle;
